// extracted by mini-css-extract-plugin
export default {"container":"ChargingTokenDetailsTabs_container__iNCbB","tab":"ChargingTokenDetailsTabs_tab__wEVMn","text":"ChargingTokenDetailsTabs_text__cpiq0"};